import axios from "axios";
import { Action } from "../actionType";

export const actionBase = axios.create({
  baseURL: Action.Base,
});

export async function postApiWithoutToken(action, param) {
  return await new Promise((resolve, reject) => {
    actionBase.post("/" + action, param).then(
      (res) => {
        resolve(res.data);
      },
      (err) => {
        console.log("error on postapi");
        console.log(err);
        reject(err);
      }
    );
  });
}

export async function getApiWithoutToken(action) {
  return await new Promise((resolve, reject) => {
    actionBase.get("/" + action).then(
      (res) => {
        resolve(res.data);
      },
      (err) => {
        console.log("hello error getApiWithoutToken");
        console.log("action:", action);
        console.log("actionBase URL:", actionBase.defaults.baseURL);
        console.log(err);
        reject(err);
      }
    );
  });
}

export async function getApiWithoutTokenAbsoluteURL(action) {
  return await new Promise((resolve, reject) => {
    actionBase.get(action).then(
      (res) => {
        resolve(res.data);
      },
      (err) => {
        console.log("hello error getApiWithoutToken");
        console.log(err);
        reject(err);
      }
    );
  });
}
